/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */


const icon = wp.element.createElement(
    'svg',
    {
      width: "800px",
      height: "800px",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    wp.element.createElement('path', {
      d: `M4 4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H10C10.5523 20 11 19.5523 11 19V5C11 4.44772 10.5523 4 10 4H4Z`,
      fill: "black"
    }),
    wp.element.createElement('path', {
      d: `M13 4C12.4477 4 12 4.44772 12 5V19C12 19.5523 12.4477 20 13 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44772 20.5523 4 20 4H13Z`,
      fill: "black"
    }),
    wp.element.createElement('path', {
      d: `M4 4L10 4`,
      stroke: "black",
      strokeWidth: "1.5"
    }),
    wp.element.createElement('path', {
      d: `M13 4L20 4`,
      stroke: "black",
      strokeWidth: "1.5"
    }),
    wp.element.createElement('circle', {
      cx: "12",
      cy: "12",
      r: "6",
      fill: "white",
      stroke: "black",
      strokeWidth: "1.5"
    }),
    wp.element.createElement('path', {
      d: `M12 6V12H16`,
      stroke: "black",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    wp.element.createElement('path', {
      d: `M12 12L14 10`,
      stroke: "black",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
  
  

registerBlockType( metadata.name, {
	icon,
	/**
	 * @see ./edit.js
	 */
	edit: Edit,
	/**
	 * @see ./save.js
	 */
	save,
} );
